/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import Logo from '@/components/logo/BMWLogo';
import styles from './MobileHeader.module.scss';

/**
 * Provides the Application Header Logo Component when in Desktop Mode.
 */
export const MobileHeaderLogo = () => (
  <div className={styles.logo} style={{flexGrow: 1}}>
    <Logo />
  </div>
);

export default MobileHeaderLogo;
